const SUBMIT = 'SUBMIT';

const DONE = 'done';

const CONTINUE = 'continue';

const GO_BACK = ' GO BACK';
const NEW_CONTACT_TITLE = "Confirm Details"
const CB_API_KEY = "atd6DA5fuQ63"

export {
    SUBMIT,
    DONE,
    CONTINUE,
    GO_BACK,
    NEW_CONTACT_TITLE,
    CB_API_KEY
};

